import { AwsRumConfigData} from "src/serviceClients/aws-rum/awsRum-configData";
import AwsRumDomain from "src/serviceClients/aws-rum/awsRum-domain";
import AwsRumRealm from "src/serviceClients/aws-rum/awsRum-realm";

// RUM configuration - these will be populated by build process from CDK outputs
export const RumConfigDependencies: Record<AwsRumDomain, Record<AwsRumRealm, AwsRumConfigData>> = {

    [AwsRumDomain.Gamma]: {
        [AwsRumRealm.EU_WEST_1]: {
            guestRoleArn: 'arn:aws:iam::127214202060:role/RnRIVRumRole-gamma-eu-wes-RumUnauthenticatedRole60F-FdM7Rl9iUaXE',
            identityPoolId: 'eu-west-1:521654a1-2a4d-4108-9c9c-45679c4bcb1d',
            endpoint: 'https://dataplane.rum.eu-west-1.amazonaws.com',
            APPLICATION_ID: '8a561f39-76e8-45bc-84fd-48de1702a6ad',
            APPLICATION_REGION: AwsRumRealm.EU_WEST_1,
            APPLICATION_VERSION: '1.0.0',
        },
        [AwsRumRealm.US_EAST_1]: {
            guestRoleArn: 'arn:aws:iam::329599642434:role/RnRIVRumRole-gamma-us-eas-RumUnauthenticatedRole60F-xPBn3jp2cvCU',
            identityPoolId: 'us-east-1:5029a9e2-f41d-449b-aaca-49563f42738f',
            endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
            APPLICATION_ID: '91e242ce-2ba5-43bb-8a17-6bc420b28c14',
            APPLICATION_REGION: AwsRumRealm.US_EAST_1,
            APPLICATION_VERSION: '1.0.0',

        },
        [AwsRumRealm.US_WEST_2]: {
            guestRoleArn: 'arn:aws:iam::575108933326:role/RnRIVRumRole-gamma-us-wes-RumUnauthenticatedRole60F-foJ4FWD90V1I',
            identityPoolId: 'us-west-2:632efd43-7bfc-4b88-8de8-cf881ef04f4a',
            endpoint: 'https://dataplane.rum.us-west-2.amazonaws.com',
            APPLICATION_ID: '65ec66d8-24ca-4997-baf0-4a354621499b',
            APPLICATION_REGION: AwsRumRealm.US_WEST_2,
            APPLICATION_VERSION: '1.0.0',
        }
    },

    [AwsRumDomain.Prod]: {
        [AwsRumRealm.EU_WEST_1]: {
            guestRoleArn: 'arn:aws:iam::711387129566:role/RnRIVRumRole-prod-eu-west-RumUnauthenticatedRole60F-inYzZnUpWVWa',
            identityPoolId: 'eu-west-1:183495c6-e9fa-44f3-a91e-3f6a7ec2ff6d',
            endpoint: 'https://dataplane.rum.eu-west-1.amazonaws.com',
            APPLICATION_ID: '9fc0ae44-d837-459a-b938-9d7eab121aa0',
            APPLICATION_REGION: AwsRumRealm.EU_WEST_1,
            APPLICATION_VERSION: '1.0.0',
        },
        [AwsRumRealm.US_EAST_1]: {
            guestRoleArn: 'arn:aws:iam::051826715171:role/RnRIVRumRole-prod-us-east-RumUnauthenticatedRole60F-qanGDmBUvFwG',
            identityPoolId: 'us-east-1:f8a05a4a-5c84-4f44-b6dd-08c7454d530b',
            endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
            APPLICATION_ID: 'dc705e26-36db-42f1-b34c-73eb376e7679',
            APPLICATION_REGION: AwsRumRealm.US_EAST_1,
            APPLICATION_VERSION: '1.0.0',

        },
        [AwsRumRealm.US_WEST_2]: {
            guestRoleArn: 'arn:aws:iam::047719626568:role/RnRIVRumRole-prod-us-west-RumUnauthenticatedRole60F-eDc04nOWVuLw1',
            identityPoolId: 'us-west-2:0c576d81-cf5d-454c-8758-e019b0ea715f',
            endpoint: 'https://dataplane.rum.us-west-2.amazonaws.com',
            APPLICATION_ID: 'b144705d-69ee-4cff-8088-554fc9c49f74',
            APPLICATION_REGION: AwsRumRealm.US_WEST_2,
            APPLICATION_VERSION: '1.0.0',
        }
    }
};
